import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AgentService } from 'src/app/agent/services/agent.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: '',
  template: '',
})
export class DashboardBalanceHandler extends BaseSearchComponent<AgentService> implements OnInit, OnChanges {
  public searchName: string = null;
  public dashboardBalance: any = [];
  // searchCriteriaData: any = {};
  // responseIO: any;

  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router);
  }

  ngOnInit() {
    super.ngOnInit();
    //console.log(this.service.searchResponseIO);
    setTimeout(() => {
      this.getDashboardBalance();
    }, 10);
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    setTimeout(() => {
      this.getDashboardBalance();
    }, 10);
  }

  getDashboardBalance() {
    this.service.getDashboardBalance().subscribe(
      (dashboardBalance) => {
        const data = dashboardBalance?.['data'] || [];

        this.dashboardBalance = data.map((item: any[]) => ({
          data: item,
          randomColor: this.generateReadableColor(),
        }));
      },
      (error) => {
        console.error('Error fetching dashboard balance:', error);
      }
    );
  }

  isNumeric(value: any): boolean {
    return value !== null && value !== '' && !isNaN(+value);
  }

  generateReadableColor(): string {
    const base = 130;
    const variance = 80;

    const r = Math.floor(Math.random() * variance + base);
    const g = Math.floor(Math.random() * variance + base);
    const b = Math.floor(Math.random() * variance + base);

    return `rgb(${r}, ${g}, ${b})`;
  }

  definitionClick(definition: any) {
    // console.log(definition);
    this.settingService.setSessionStorageValue('definitionType', definition);
    let link = null;

    if (definition == 'COMMISSION') link = '/search-commission-details';
    else if (definition == 'COMPENSATION') link = '/search-incentive';
    else link = '/search-balance-details';

    this.router.navigate([link]);
  }
}
